<template>
  <div>
    <v-row justify="center" align="center">
      <v-col cols="12" md="12" sm="12">
        <v-banner icon="mdi-card-search-outline">
          Your Orders
          <template v-slot:actions>
            <v-btn text color="blue darken-2" exact :to="{name: 'YourOrders'}">
              <v-icon left>arrow_back</v-icon>Back
            </v-btn>
          </template>
        </v-banner>
        <v-toolbar flat>
          <v-toolbar-title
            class="subtitle-2 font-weight-medium"
          >Delivery Date : {{getDeliveryDate()}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-title class="subtitle-2 font-weight-medium">Order Ref : {{orderRef}}</v-toolbar-title>
        </v-toolbar>
        <v-data-table :headers="headers" :items="tickets" hide-default-footer class="elevation-0">
          <template v-slot:item.total="{item}">
            <span>
              <span class="font-weight-medium">£ {{item.net_total}}</span>
            </span>
          </template>
          <template v-slot:item.actions="{item}">
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-btn icon color="primary" v-on="on" @click.stop="goToDetailsPage(item)">
                  <v-icon>info</v-icon>
                </v-btn>
              </template>
              <span>More Information</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import moment from "moment";

export default {
  name: "OrderDetails",
  data: () => {
    return {
      headers: [
        { text: "Distributor Name", value: "distributor_name" },
        { text: "Invoice No", value: "invoice_no", sortable: false },
        { text: "Invoice Total", value: "total", sortable: false },
        { text: "Actions", value: "actions", sortable: false }
      ]
    };
  },
  computed: {
    tickets() {
      return this.$store.state.ordersHistory.orderTickets;
    },
    orderRef() {
      return this.$route.params.td_id;
    }
  },
  methods: {
    getDeliveryDate() {
      let order = this.$store.state.ordersHistory.orders.find(
        order => order.td_id === this.orderRef
      );
      let deliveryDate = "";
      if (order) {
        deliveryDate = order.transaction_date;
      }

      return deliveryDate
        ? moment(deliveryDate).format("dddd, Do MMMM YYYY")
        : "";
    },
    goToDetailsPage(order) {
      let item = this.$store.state.ordersHistory.orders.find(
        order => order.td_id === this.orderRef
      );

      this.getOrderProducts(order);
      this.$router.push({
        name: "TicketDetails",
        params: { td_id: item.td_id, invoice_no: order.invoice_no }
      });
    },
    getOrderProducts(ord) {
      this.$store
        .dispatch("fetchOrdersProducts", { tdId: ord.tdd_id })
        .then(response => {
          if (response == true) {
            console.log("Products Found And Retrieved");
          } else {
            console.log("Failed to retreive Order Products");
          }
        })
        .catch(er => {
          console.log(er);
        });
    }
  }
};
</script>